module.exports = __webpack_public_path__ + "img/420bc34.jpg";